import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { Cerere } from '../../cerere.interface';
import { CereriService } from '../../cereri.service';
import { IOrar, formConfigurations } from './informatii-aditionale';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-informatii-aditionale',
    templateUrl: './informatii-aditionale.component.html',
    styleUrls: ['./informatii-aditionale.component.scss']
})
export class InformatiiAditionaleComponent implements OnChanges {
    @Input() cerere!: Cerere;
    @Output() cerereChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    selectedInfoStatus = 'info';

    helper = helper;

    has_checkbox_details = false;

    currentFormFields: Array<{
        label: string;
        value: string;
        fieldType: 'info' | 'suprafata' | 'taxa';
        type?: string;
        isCheckboxField?: boolean;
    }> = [];

    formattedOrar: any[] = [];

    weekDays: { [key: number]: string } = {
        1: 'Luni',
        2: 'Marți',
        3: 'Miercuri',
        4: 'Joi',
        5: 'Vineri',
        6: 'Sâmbătă',
        7: 'Duminică'
    };

    constructor(private cereriService: CereriService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['cerere']) {
            this.currentFormFields = this.getCurrentFormFields();

            if (this.cerere?.informatii?.orar && this.cerere?.informatii?.orar?.length > 0) {
                this.formattedOrar = this.formatOrar();
            }
        }
    }

    getCurrentFormFields(): Array<{
        label: string;
        value: string;
        fieldType: 'info' | 'suprafata' | 'taxa';
        type?: string;
        isCheckboxField?: boolean;
    }> {
        let currentSlug = this.cerere?.slug || 'default-slug';

        const allFields = formConfigurations[currentSlug] || [];

        // Mark checkbox fields
        return allFields.map((field) => {
            return {
                ...field,
                isCheckboxField: field.value.includes('.'),
            };
        });
    }

    formatOrar(): { dayName: string, businessHours: string }[] {
        const orar: IOrar[] = this.cerere.informatii.orar;

        let formattedOrar = orar.map((day) => {
            let businessHours = '';

            if (day.inchis === 1) {
                businessHours = 'Închis'
            } else if (day.nonstop === 1) {
                businessHours = 'Nonstop'
            } else if (day.from !== null && day.stop !== null) {
                businessHours = `${day.from}:${day.stop}`
            } else {
                businessHours = 'N/A'
            }

            return {
                dayName: this.weekDays[day.day],
                businessHours: businessHours,
            }
        })

        return formattedOrar;
    }

    onInfoChange(event: MatButtonToggleChange) {
        this.selectedInfoStatus = event.value;
    }

    mapAcordProprietate(controlValue: string) {
        if (controlValue) {
            if (controlValue == '1') {
                return 'Într-un spațiu condomeniu';
            } else if (controlValue == '2') {
                return 'În zona de case';
            }
        }

        return 'N/A';
    }

    mapActDetinereSpatiu(controlValue: string) {
        if (controlValue) {
            if (controlValue == '1') {
                return 'Contract de închiriere';
            } else if (controlValue == '2') {
                return 'Act de proprietate';
            } else if (controlValue == '3') {
                return 'Contract de comodat';
            }
        }

        return 'N/A';
    }

    mapPlataTaxa(controlValue: string) {
        if (controlValue) {
            if (controlValue == '1') {
                return 'Chitanță';
            } else if (controlValue == '2') {
                return 'Online - Portal';
            }
        }

        return 'N/A';
    }
}
